import {
  AtlasBodyMain,
  AtlasBodySubtitle,
  BottomGroupMolecule,
  ConfirmationDialogMolecule,
  PageContentAtom,
  PrimaryButtonAtom,
  ToolbarMolecule
} from '@justomx/atlas-components'
import { useTranslation } from 'react-i18next'

import LoaderAtom from 'components/atoms/Loader.atom'
import { StackAtom } from 'components/atoms/Stack.atom'
import { InstructionsMolecule } from 'components/molecule/Instructions.molecule'
import { NoDataMolecule } from 'components/molecule/NoData.molecule'
import { ScannerMolecule } from 'components/molecule/Scanner.molecule'
import { InputDialogOrganism } from 'components/organisms/InputDialog.organism'
import { OptionsDialogOrganism } from 'components/organisms/OptionsDialog.organism'
import { ProductCardOrganism } from 'components/organisms/ProductCard.organism'
import { ProductFiltersOrganism } from 'components/organisms/ProductFilters.organism'
import { TransferProgressCard } from 'components/organisms/TransferProgressCard.organism'
import { useProducts } from './Products.hook'

const ProductsPage = () => {
  const {
    docNum,
    warehouse,
    filteredProducts,
    dialogRef,
    totalContainers,
    totalProducts,
    completedSKUs,
    allProductsProcessed,
    loading,
    printerReady,
    printerDialogRef,
    missingsDialogRef,
    pickedFinished,
    actions
  } = useProducts()
  const { t } = useTranslation('global')
  const noData = !Object.values(filteredProducts)?.[0]

  return (
    <>
      {loading && <LoaderAtom>Cargando</LoaderAtom>}

      <ToolbarMolecule
        title="Productos"
        actionIcon="ic_arrow_back"
        onAction={actions.onGoBack}
        secondaryActionIcon="ic_pallet"
        thirdActionIcon="ic_keyboard"
        onSecondaryAction={actions.goToPalletsList}
        onThirdAction={actions.openKeyboard}
        fourthActionIcon={
          printerReady ? 'ic_connected_printer' : 'ic_disconnected_printer'
        }
        onFourthAction={actions.onClickPrinter}
      />

      <PageContentAtom style={{ paddingBottom: '75px' }}>
        <StackAtom $direction="column" $gap={24}>
          <TransferProgressCard
            docNum={docNum}
            warehouse={warehouse}
            palletsLabel={`${totalContainers}`}
            productsLabel={`${completedSKUs}/${totalProducts}`}
          />

          <InstructionsMolecule lines={['Escanea el producto.']} />

          <ProductFiltersOrganism onSelectFilter={actions.onSelectFilter} />

          {noData && <NoDataMolecule padding="64px 0 64px 0" />}

          {!noData && (
            <StackAtom $gap={16} $direction="column">
              {Object.entries(filteredProducts).map(([type, products]) => (
                <StackAtom key={type} $direction="column" $gap={16}>
                  <AtlasBodySubtitle>{t(`commons.${type}`)}</AtlasBodySubtitle>

                  {products.map((product) => (
                    <ProductCardOrganism
                      key={product.barcode}
                      product={{ ...product, containerId: '' }}
                      actionIcon="ic_report"
                      onClickAction={() => {
                        actions.onSelectProduct(product)
                      }}
                    />
                  ))}
                </StackAtom>
              ))}
            </StackAtom>
          )}
        </StackAtom>

        <BottomGroupMolecule bgColor="#212121">
          <PrimaryButtonAtom
            type="button"
            onClick={actions.onContinue}
            disabled={!allProductsProcessed || !pickedFinished}
          >
            Continuar
          </PrimaryButtonAtom>
        </BottomGroupMolecule>
        <ScannerMolecule mode="hidden" onScan={actions.onScanProduct} />

        <InputDialogOrganism
          dialogRef={dialogRef}
          title="Producto"
          textboxLabel="Escribe el UPC del producto"
          confirmLabel="Continuar"
          cancelLabel="Cancelar"
          confirmAction={actions.onScanProduct}
        />
        <ConfirmationDialogMolecule
          confirmOnly
          dialogRef={printerDialogRef}
          confirmText="CONTINUAR"
          onConfirm={actions.goToScanPrinter}
        >
          <StackAtom $direction="column" $gap={24}>
            <AtlasBodySubtitle>Impresora desconectada</AtlasBodySubtitle>
            <AtlasBodyMain>
              Conecta la impresora a tu hand held para poder imprimir las
              etiquetas.
            </AtlasBodyMain>
          </StackAtom>
        </ConfirmationDialogMolecule>

        <OptionsDialogOrganism
          dialogRef={missingsDialogRef}
          title="Selecciona el tipo de reporte"
          options={[
            { id: 'waste', label: 'Merma' },
            { id: 'missing', label: 'Faltante' }
          ]}
          confirmAction={actions.goToMissingPage}
        />
      </PageContentAtom>
    </>
  )
}

export default ProductsPage
